import { SegmentControls } from 'builder/components/SegmentControls'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { ResumeEditorStore, selectors } from 'builder/modules/resumeEditor'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { getAutotailoringHeaderHeight } from '../TailoringFromPublicJobBoard'
import { StyledEditorPanelSwitcherWrapper, StyledSegmentControl, TabTextContainer } from './styles'
import { useTabNavigation } from './hooks'

type Props = {
  resumeState: ResumeEditorStore
  isRbpStepFlowActive?: boolean
  canScrollTop?: boolean
}

export const StickyTabs = (props: Props) => {
  const { resumeState, isRbpStepFlowActive, canScrollTop } = props
  const mediaQueries = useMediaQueries()
  const { isAboveTablet } = mediaQueries
  const { editorPanelType } = resumeState
  const autoTailoringFromPublicJobBoard = useTypedSelector(
    selectors.autoTailoringFromPublicJobBoard,
  )
  const selectedPrefillOption = useTypedSelector(selectors.selectedPrefillOption)
  const shouldCompensateAutotailoringHeaderHeight =
    autoTailoringFromPublicJobBoard.enabled &&
    !isRbpStepFlowActive &&
    selectedPrefillOption &&
    editorPanelType !== 'customization'

  const autotailoringHeaderHeight = shouldCompensateAutotailoringHeaderHeight
    ? getAutotailoringHeaderHeight(mediaQueries)
    : 0

  const { handleTabChange, getTabItems } = useTabNavigation()
  const tabItems = getTabItems()

  if (isAboveTablet) {
    return null
  }

  return (
    <StyledEditorPanelSwitcherWrapper
      $stickyTop={autotailoringHeaderHeight}
      $isStickyState={canScrollTop || isRbpStepFlowActive}
      $canScrollTop={canScrollTop}
    >
      <SegmentControls style={{ width: '100%' }}>
        {tabItems.map(item => (
          <StyledSegmentControl
            key={item.id}
            $isActive={editorPanelType === item.id}
            onClick={() => handleTabChange(item.id)}
          >
            <TabTextContainer>{item.text}</TabTextContainer>
          </StyledSegmentControl>
        ))}
      </SegmentControls>
    </StyledEditorPanelSwitcherWrapper>
  )
}
